module.exports = __webpack_public_path__ + "static/media/ticket.b4e77f5c.svg";